import request from 'superagent'
import configApi from '../../constants/ApiConfig'
import * as session from '../../services/session'

const nl2br = (str, is_xhtml) => {
  let breakTag = is_xhtml || typeof is_xhtml === 'undefined' ? '<br />' : '<br>'
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, '$1' + breakTag + '$2')
}

const prepareValidationError = error => {
  if (!error) return error

  if (error['hydra:description']) {
    error._error = nl2br(error['hydra:description'])

    if (error.violations) {
      error.violations.map((el, index) => {
        error[el['propertyPath']] = el.message
      })
    }
  }

  return error
}

export const fetch = (url, data = {}, method = 'GET', full = false) => {
  if (!full) url = configApi.url + url

  const accessToken = session.getToken().access_token

  return new Promise((resolve, reject) => {
    let query = request(method, url)

    switch (method) {
      case 'get':
        query.query(data)

        break

      default:
        query.send(data)

        break
    }

    query.set('mode', 'no-cors')
    query.set('Authorization', `Bearer ${accessToken}`)

    query
      .then(data => {
        resolve(data.body)
      })
      .catch(error => {
        //toast.error('Une erreur inconnue est survenue');

        if (error.response) {
          reject(prepareValidationError(error.response.body))
        } else {
          reject(error)
        }
      })
  })
}

export const fetchV2 = (url, data = {}, method = 'GET', full = false) => {
  const testUrl = new RegExp('http*')
  if (!testUrl.test(url)) url = configApi.api + url

  //const accessToken = session.getToken().access_token;

  return new Promise((resolve, reject) => {
    let query = request(method, url)

    switch (method) {
      case 'get':
        query.query(data)

        break

      default:
        query.send(data)

        break
    }

    query.set('mode', 'no-cors')
    query.set('access_token', `${configApi.apiKey}`)
    //query.set('authorization', `${configApi.apiKey}`)

    query
      .then(data => {
        resolve(data.body)
      })
      .catch(error => {
        //toast.error('Une erreur inconnue est survenue');

        if (error.response) {
          reject(prepareValidationError(error.response.body))
        } else {
          reject(error)
        }
      })
  })
}



// WEBPACK FOOTER //
// ./src/services/api/index.js